const TOOLTIP_SCALE_MAP: Record<number, number> = {
  1: 1,
  0.85: 1,
  0.7: 0.85,
  0.5: 0.7,
};

// special request in PLN-4316 ticket
export const normalizeTooltipScaleFactor = (scaleFactor: number) => {
  return (
    TOOLTIP_SCALE_MAP[scaleFactor as keyof typeof TOOLTIP_SCALE_MAP] ??
    scaleFactor
  );
};

export const calculateTopOffset = (scaleFactor: number) => {
  if (scaleFactor === 1) return 18;
  if (scaleFactor === 0.85) return 16;
  if (scaleFactor === 0.7) return 12;

  return 8;
};
